import * as axios from 'axios';

export const education = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/education`;
    return axios.get(url).then((res) => {
        return res.data;
    })
};

export const courseType = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/jzsh/options/course-type`;
    return axios.get(url).then((res) => {
        return res.data;
    })
};

export const gradingSystem = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/jzsh/options/grading-system`;
    return axios.get(url).then((res) => {
        return res.data;
    })
};